import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import Api from "../Utils/api";
import NotificationSystem from "react-notification-system";

class CartComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cartAdd: props.cart?.cartName || "", // Initialize with existing cart name if editing
    };

    this.handleCartAdd = this.handleCartAdd.bind(this);
    this.addNotification = this.addNotification.bind(this);
    this.addCart = this.addCart.bind(this);
    this._notificationSystem = null;
    this.editCart = this.editCart.bind(this);
  }
  addNotification(message, level) {
    if (this._notificationSystem) {
      this._notificationSystem.addNotification({
        message: message,
        level: level,
      });
    }
  }
  handleCartAdd(event) {
    this.setState({ cartAdd: event.target.value });
  }
  addCart(event) {
    event.preventDefault();
    const { cartAdd } = this.state;
  
    if (!cartAdd.trim()) {
      this.addNotification("Cart name cannot be empty!", "error");
      return;
    }
  
    const data = {
      cartId: Math.floor(Math.random() * 10000),
      cartName: cartAdd,
      cartStatus: true,
    };
  
    Api.post(`EstimateSummary/AddCart`, data)
      .then((response) => {
        this.setState({ cartAdd: "" }); 
        this.props.setShowModal(false); 
        if (typeof this.props.getCarts === "function") {
          this.props.getCarts();
        }
        this.addNotification(response.data.message === null ? "Cart created successfully!" : response.data.message, "success");
      })
      .catch((error) => {
        this.addNotification("Error creating cart: " + error, "error");
      });
  }
  

  editCart(event) {
    event.preventDefault();
    const { cartAdd } = this.state;
    const { cart, updateOrderSummary } = this.props;
  
    if (!cart?.id) {  // ✅ Ensure the correct ID key is used
      this.addNotification("No cart ID provided for editing.", "error");
      return;
    }
  
    const data = {
      cartId: cart.id,
      cartName: cartAdd,
      cartStatus: true,
    };
  
    Api.put(`EstimateSummary/EditCart`, data)
      .then(() => {
        this.setState({ cartAdd: "" }); 
        this.props.setShowModal(false); 
        this.addNotification("Cart updated successfully!", "success");
  
        updateOrderSummary(cart.id, cartAdd); // ✅ Ensure the function is called
      })
      .catch((error) => {
        this.addNotification("Error updating cart: " + error, "error");
      });
  }
  
  

  render() {
    let notificationStyle = {
      NotificationItem: {
        DefaultStyle: {
          margin: "10px 5px 2px 1px",
          padding: "30px",
          wordBreak: "break-word",
        },
      },
    };
    const { showModal, setShowModal, cart } = this.props;
    const isEditing = cart?.id; // Check if editing
    return (
      <>
        <NotificationSystem
          ref={(notificationSystem) => (this._notificationSystem = notificationSystem)}
          style={notificationStyle}
        />
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <span role="img" aria-label="Shopping Cart">🛒</span> {isEditing ? "Edit Cart" : "Add Cart"}
          </Modal.Title>
        </Modal.Header>
          <Modal.Body>
            <form>
              <h5>Enter Cart Name</h5>
              <input
                type="text"
                name="cartAdd"
                placeholder="Enter Cart Name"
                onChange={this.handleCartAdd}
                value={this.state.cartAdd || cart?.cartName}
                className="form-control"
              />
            </form>
          </Modal.Body>

          <Modal.Footer>
          <Button variant="outline-dark" onClick={() => setShowModal(false)}>
            <span role="img" aria-label="Close">❌</span> Close
          </Button>
            <Button
              type="submit"
              onClick={isEditing ? this.editCart : this.addCart}
              variant="primary"
              disabled={!this.state.cartAdd.trim()}
            >
              {isEditing ? "✏️ Update Cart" : "➕ Save Cart"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default CartComponent;
